// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sim-card"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 2V22H4V6L8 2H20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 2V22H4V6L8 2H20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 13V16M12 10V13M15 13V16M15 9.99805H15.0039V10.002H15V9.99805ZM11.998 15.998H12.002V16.002H11.998V15.998ZM9 9.99805H9.00391V10.002H9V9.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SimCardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sim-card',
    ref,
    icon: element,
  },
));

SimCardIcon.displayName = 'SimCardIcon';

export default SimCardIcon;
